<template>
    <div class="qr-code-btn d-inline-block" :class="{'is-disabled': disabled}">
        <button
            :class="`btn btn-default btn-${size} dropdown-toggle`"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            :disabled="disabled"
        >
            <i class="far fa-qrcode"></i>
        </button>
        <ul class="dropdown-menu" :class="dropdownClasses" @click="doDownload">
            <li>
                <a href="javascript:void(0)" data-type="png">Download QR code (PNG)</a>
            </li>
            <li>
                <a href="javascript:void(0)" data-type="svg">Download QR code (SVG)</a>
            </li>
        </ul>
    </div>
</template>

<script>

export default {
    name: 'BaseQrCodeButton',
    props: {
        size: {
            type: String,
            default: 'md',
        },
        direction: {
            type: String,
            default: '',
            validator: (value) => ['', 'right'].includes(value),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        dropdownClasses() {
            return {
                'dropdown-menu-right': this.direction === 'right',
            };
        },
    },
    methods: {
        doDownload({ target: { dataset: { type } } }) {
            if (type) {
                this.$emit('download-qr-code', type);
            }
        },
    },
}
</script>
